import MachineUsageStatsContainer from 'components/feature/statistics/machine/MachineUsageStatsContainer';

const MachineUsageStatsPage = () => {
  return <MachineUsageStatsContainer />;
};
export default MachineUsageStatsPage;
